export default "__VITE_ASSET__BNewK6Qi__"